import React, { useState, useEffect } from 'react';
import './AdminCoupon.css';
import Modal from '../../components/Modal';

const AdminCoupon = () => {
  const [open, setOpen] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [formData, setFormData] = useState({
    code: '',
    type: 'fixed',
    value: '',
    min_order_value: '',
    max_discount: '',
    expiry_date: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });


  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken') || localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  };

  
  const fetchAllCoupons = async () => {
    try {
      const response = await fetch('https://rbuymart.rbhardwaj.com/server/api/admin/manage_coupons.php', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const resData = await response.json();
      if (resData.status === 'success') {
        setCoupons(resData.data);
      } else {
        console.error("Fetch failed:", resData.message);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };

  useEffect(() => {
    fetchAllCoupons();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await fetch('https://rbuymart.rbhardwaj.com/server/api/admin/manage_coupons.php', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });

      const resData = await response.json();

      if (resData.status === 'success') {
        setMessage({ type: 'success', text: 'Coupon created successfully!' });
        setFormData({ code: '', type: 'fixed', value: '', min_order_value: '', max_discount: '', expiry_date: '' });
        fetchAllCoupons(); 
      } else {
        setMessage({ type: 'error', text: resData.message || 'Something went wrong.' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Unable to connect to server.' });
    } finally {
      setLoading(false);
    }
  };


  const handleToggleStatus = async (id, currentStatus) => {
    const nextStatus = currentStatus === '1' ? '0' : '1';
    try {
      const response = await fetch('https://rbuymart.rbhardwaj.com/server/api/admin/manage_coupons.php', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ id, status: nextStatus }),
      });

      const resData = await response.json();
      if (resData.status === 'success') {
        setMessage({ type: 'success', text: 'Coupon status updated successfully.' });
        fetchAllCoupons();
      } else {
        setMessage({ type: 'error', text: resData.message || 'Failed to update status.' });
      }
    } catch (error) {
      console.error("Status toggle error:", error);
    }
  };


  const handleDeleteCoupon = async (id) => {
    if (!window.confirm("क्या आप वाकई इस कूपन को डिलीट करना चाहते हैं?")) return;
    
    try {
      const response = await fetch(`https://rbuymart.rbhardwaj.com/server/api/admin/manage_coupons.php?id=${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      const resData = await response.json();
      if (resData.status === 'success') {
        setMessage({ type: 'success', text: 'कूपन डिलीट कर दिया गया है।' });
        fetchAllCoupons();
      } else {
        setMessage({ type: 'error', text: resData.message || 'Delete failed.' });
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <div className="admin-coupon-page-layout">
      <div class="admin-header-tap">
     
          <h3>Coupons</h3>
        <div className="flex-div">
    <button onClick={() => setOpen(true)} className="btn-add">
       <i class="material-icons">&#xe146;</i> Add
      </button>
    <button onClick={() => window.print()} className="btn-print">
            <i className="material-icons">&#xe8ad;</i> Print
          </button>
        </div>
        </div>
    <Modal
            
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Create Coupon"
      >
    
        {message.text && <div className={`alert-box ${message.type}`}>{message.text}</div>}
        

        <form onSubmit={handleSubmit} className="admin-coupon-form">
          <div className="formlabeldiv">
          
            <input 
              type="text" name="code" value={formData.code} onChange={handleChange} 
            required style={{ textTransform: 'uppercase' }}
            />
              <label>Coupon Code</label>
          </div>

          <div className="formlabeldiv">
        
            <select name="type" value={formData.type} onChange={handleChange}>
              <option value="fixed">Fixed Amount (₹)</option>
              <option value="percentage">Percentage (%)</option>
            </select>
                <label>Discount Type</label>
          </div>

          <div className="input-group">
             <div className="formlabeldiv">
            
              <input type="number" name="value" value={formData.value} onChange={handleChange} required min="1" />
                <label>Discount Value {formData.type === 'percentage' ? '(%)' : '(₹)'}</label>
            </div>

           <div className="formlabeldiv">
           
              <input type="number" name="min_order_value" value={formData.min_order_value} onChange={handleChange} />
                 <label>Min Order Value (₹)</label>
            </div>
          </div>

          {formData.type === 'percentage' && (
             <div className="formlabeldiv">
             
              <input type="number" name="max_discount" value={formData.max_discount} onChange={handleChange} />
               <label>Max Discount Limit (₹) <small>(Optional)</small></label>
            </div>
          )}

       <div className="formlabeldiv">
           
            <input type="date" name="expiry_date" value={formData.expiry_date} onChange={handleChange} required />
             <label>Expiry Date</label>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? 'Creating...' : 'Generate Coupon'}
          </button>
        </form>

      </Modal>
   

      {/* 2. टेबल सेक्शन */}
      <div className="coupon-table-container">
        <div className="table-div">
          <table>
            <thead>
              <tr>
                <th>Code</th>
                <th>Type</th>
                <th>Value</th>
                <th>Min Order</th>
                <th>Max Disc.</th>
                <th>Expiry</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {coupons.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                    No coupons found in database.
                  </td>
                </tr>
              ) : (
                coupons.map((cp) => (
                  <tr key={cp.id}>
                    <td className="coupon-code-cell"><code>{cp.code}</code></td>
                    <td><span className={`badge-type ${cp.type}`}>{cp.type}</span></td>
                    <td>{cp.type === 'percentage' ? `${cp.value}%` : `₹${Number(cp.value).toLocaleString('en-IN')}`}</td>
                    <td>₹{Number(cp.min_order_value).toLocaleString('en-IN')}</td>
                    <td>{cp.max_discount ? `₹${Number(cp.max_discount).toLocaleString('en-IN')}` : '-'}</td>
                    <td>{cp.expiry_date}</td>
                    <td>
                      <button 
                        onClick={() => handleToggleStatus(cp.id, cp.status)}
                        className={`btn-status-toggle ${cp.status === '1' ? 'inactive' : 'active'}`}
                      >
                        {cp.status === '1' ? 'Inactive' : ' Active'}
                      </button>
                    </td>
                    <td>
                      <button 
                        onClick={() => handleDeleteCoupon(cp.id)} 
                        className="btn-delete"
                      >
                        <i className="material-icons">&#xe872;</i> Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminCoupon;